<div role="navigation"
     [attr.aria-label]="'tdWb.menu.GLOBAL' | tdWbTranslate">
  <!-- Second from the top menu bar with global links  -->
  <h2 id="td-wb-aria-global-nav-header"
      class="td-wb-vh">
    <span translate="tdWb.menu.GLOBAL_HEADER"></span>
  </h2>
  <ul class="td-wb-global-navigation__list"
      aria-labelledby="td-wb-aria-global-nav-header">
    @for (item of navigationMenu; track item; let first = $first) {
      <li class="td-wb-global-navigation__list-item">
        @if (!item.menu) {
          <a class="td-wb-global-navigation__link"
             [attr.target]="item.target"
             [href]="item.href"
             [innerHtml]="item.text"></a>
        }
        @if (item.menu) {
          <td-wb-top-navigation-item
            [item]="item"
            [ngClass]="{ 'td-wb-top-navigation-item--first': first }"
            id="td-wb-global-navigation-product-service"
            [flyoutMenuUserData]="flyoutMenuUserData"
            [overlayPosition]="FlyoutMenuOverlayPosition.START_BOTTOM">
            <td-wb-flyout-menu
              #flyoutMenuUserData="tdWbFlyoutMenu">
              @for (subItem of item.menu[0].item; track subItem) {
                <div class="td-wb-global-navigation__content">
                  @if (subItem !== undefined) {
                    <a role="button"
                       [attr.target]="subItem.target === undefined ? undefined:subItem.target"
                       id="td-wb-global-navigation__content__item-1"
                       [href]="subItem.href"
                       tdWbFlyoutMenuItem>
                      <span class="td-wb-global-navigation__menu-item">
                        <span class="td-wb-global-navigation__menu-item-text"
                              [innerHtml]="subItem.text"></span>
                      </span>
                    </a>
                  }
                </div>
              }
            </td-wb-flyout-menu>
          </td-wb-top-navigation-item>
        }
      </li>
    }
  </ul>
</div>
